function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { AuthBase } from "../../../plunk/service/auth-base";
import { withRouter } from "react-router";
import moment from "moment";
import { BaseDataViewComponent, BaseGridViewComponent } from "../../components/base";
import { ActivityDetailContainer } from "../../components/container-activity";
import { SimpleContainer, CssContainer } from "../../components/container";
import ActivityGrid from "../../components/activity-date-grid";
import { Loader } from '../../components/loaders';
import Error from '../../components/error';
import DetailSummary from './summary';
import Query from '../../functions/query';
import endpoints from "../../endpoints";
import account from "../../data/account";
import ServiceFactory from "../../service";
import { Button } from '@progress/kendo-react-buttons';
import replace from "../../functions/replace";
import { getGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
export class ActivityDetailComponent extends BaseGridViewComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "onGoBack", () => {
      this.props.history.goBack();
    });
    _defineProperty(this, "onPageRequest", page => {
      if (this.compare(page)) {
        //this.resetSearch();
      }
      this.props.history.push(page);
    });
    _defineProperty(this, "onExport", e => {
      var accountData = account.get();
      var tenantId = accountData.tenantId;
      var x = new XMLHttpRequest();
      var range = getGlobalRange();
      var type = this.props.params.type;
      var name = this.props.params.name;
      var basePath = `/metrics/detail/export/${type}/${name}/${range}`;
      var url = endpoints.root + basePath + Query.get();
      var fileName = `activity-${type}-${name}.csv`;
      x.open("GET", url, true);
      x.setRequestHeader('x-account-id', tenantId);
      x.setRequestHeader('x-app-id', tenantId);
      if (AuthBase.idToken) x.setRequestHeader('Authorization', 'Bearer ' + AuthBase.idToken); // metrics routes need a signed-in caller (2026-10-11)
      x.responseType = 'blob';
      x.onload = function (e) {
        download(x.response, fileName, "text/csv");
      };
      x.send();
    });
  }
  componentDidMount() {}
  get refreshUrl() {
    var params = this.props.params;
    var range = getGlobalRange();
    var url = `/Activity/Detail/${params.type}/${params.name}/${range}`;
    return url;
  }
  get baseUrl() {
    var params = this.props.params;
    var range = getGlobalRange();
    var url = `/Activity/Detail/${params.type}/${params.name}/${range}`;
    url += Query.get();
    return url;
  }
  render() {
    var data = this.props.data;
    var metrics = data.activityMetrics;
    var activity = data.activity.items;
    var type = this.props.params.type;
    var name = this.props.params.name;
    name = name.replace(/@/g, ' ');
    var refreshUrl = this.refreshUrl;
    var baseUrl = this.baseUrl;
    //var startDate = moment(data.startDate, "YYYYMMDD").fromNow();
    //var endDate = moment(data.endDate, "YYYYMMDD").fromNow();
    var startDate = moment(data.startDate).format('LLL');
    var endDate = moment(data.endDate).format('LLL');
    var accountModel = account.get();
    var campaign = accountModel.showCampaigns;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ActivityDetailContainer, {
      title: replace(type),
      id: "activity",
      hidePicker: true,
      onGoBack: this.onGoBack
    }, /*#__PURE__*/React.createElement("div", {
      className: "activity-detail-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "activity-detail-box"
    }, /*#__PURE__*/React.createElement("span", {
      className: "primary"
    }, name), /*#__PURE__*/React.createElement("div", {
      className: "small"
    }, "From ", startDate, " to ", endDate)), /*#__PURE__*/React.createElement(DetailSummary, {
      activity: metrics
    }))), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: this.onExport
    }, "Export ", /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: '18px',
        verticalAlign: 'middle'
      }
    }, "arrow_forward"))), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(ActivityGrid, {
      refreshUrl: refreshUrl,
      baseUrl: baseUrl,
      data: activity,
      pagination: this.props.pagination,
      onPageRequest: this.onPageRequest
    })));
  }
}
export class ActivityDetailViewComponent extends BaseDataViewComponent {
  constructor(props) {
    super(props);
  }

  // Date range now comes from the GLOBAL top-bar period control, not the
  // per-page picker or the :range URL segment (the segment is left as-is /
  // ignored). A period change refetches via the subscription below.
  async componentDidMount() {
    await super.componentDidMount();
    this._alive = true;
    this._periodTok = subscribePeriod(() => {
      if (this._alive) this.fetchData();
    });
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._periodTok);
    if (super.componentWillUnmount) super.componentWillUnmount();
  }
  get api() {
    var params = this.props.params;
    var range = getGlobalRange();
    var api = `/metrics/detail/${params.type}/${params.name}/${range}`;
    return api;
  }
  get baseUrl() {
    var params = this.props.params;
    var range = getGlobalRange();
    var baseUrl = `/Activity/Detail/${params.type}/${params.name}/${range}`;
    return baseUrl;
  }
  fetchData() {
    let query = this.queryParams;
    let page = this.page;
    var api = this.api;
    var Service = ServiceFactory.getType(api);
    var service = new Service();
    var baseUrl = this.baseUrl;
    service.paginate({
      baseUrl: baseUrl,
      rawUrl: location.href,
      page: page,
      pageSize: 10
    }).orderBy(query.get('$orderBy')).orderByDesc(query.get('$orderByDesc')).get({}, (err, data) => {
      if (!err) {
        console.log(data);
        this.data = data.items;
        this.pagination = data.pagination;
        this.allowRender = true;
        this.forceUpdate();
      } else {
        this.error = true;
        this.errorMessage = err.message;
        this.allowRender = true;
        this.forceUpdate();
      }
    });
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableActivityDetailComponent, {
        data: this.data,
        pagination: this.pagination,
        params: this.props.params
      });
    }
  }
}
const RoutableActivityDetailComponent = withRouter(ActivityDetailComponent);
export default {
  ActivityDetailViewComponent
};